import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { App_FormBloc, App_FormStep } from 'src/app/utils/interfaces';

@Pipe({
  name: 'getGroupInFormPipe'
})
export class GetGroupInFormPipe implements PipeTransform {

  transform(form: FormGroup, step: App_FormStep, bloc: App_FormBloc, fieldOrLabel: any): FormGroup | null {
    const stepformGroup = form.controls[step.name];
    if (stepformGroup instanceof FormGroup) {
      const blocFormGroup = stepformGroup.controls[bloc.name]
      if (blocFormGroup instanceof FormGroup) {
        const fieldControl = blocFormGroup.controls[fieldOrLabel.name]
        return fieldControl instanceof FormGroup
        ? fieldControl
        : null
      }
    }
    return null;
  }

}
